import PersonaPage from "./PersonaPage";
import { questionsPersonFemale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für die Schwester?",
    a: "Beginnen Sie in der Kindheit — bei einem gemeinsamen Zimmer, einem Streit, einem Sommer. Bei Schwestern trägt oft eine kleine, komplizenhafte Szene die ganze Rede.",
  },
  {
    q: "Meine Schwester und ich waren sehr unterschiedlich. Wie schreibe ich das?",
    a: "Genau darin liegt oft die Würdigung. Zwei Wege aus demselben Zuhause, zwei Sprachen aus derselben Küche. Eine Rede darf das feiern, statt es zu glätten.",
  },
  {
    q: "Wie persönlich darf ich werden?",
    a: "So persönlich, wie es ihr entsprochen hätte. Eine Anekdote, ein Kosename, ein Insider — genau das unterscheidet Rede von Nachruf.",
  },
  {
    q: "Können wir Fotos oder Lieder einbeziehen?",
    a: "Direkt im Entwurf nicht — aber Sie können im Fragebogen ein Lied oder ein wiederkehrendes Bild hinterlegen, das wir behutsam einweben.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für den Bruder", to: "/trauerrede-bruder" },
  { label: "Trauerrede für die Mutter", to: "/trauerrede-mutter" },
  { label: "Trauerrede für eine Freundin", to: "/trauerrede-freund" },
];

export default function TrauerredeSchwester() {
  return (
    <PersonaPage
      slug="trauerrede-schwester"
      metaTitle="Trauerrede für die Schwester schreiben — persönlich & würdevoll | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für die Schwester. Aus geteilten Kindheitsjahren und leisen Insidern entsteht ein würdevoller Entwurf in acht Fragen. Ab 29 €."
      eyebrow="Trauerrede · Schwester"
      headline={
        <>
          Eine Trauerrede für die Schwester.
          <br />
          <span className="italic text-umber">Zwei Wege. Ein Zuhause.</span>
        </>
      }
      intro="Eine Schwester weiß, welcher Ton fällt, bevor die Tür aufgeht. Sie hat die gleichen Sätze der Eltern im Ohr — und ihre eigenen dazwischen. Ein behutsamer erster Entwurf, aus acht ruhigen Fragen und Ihren gemeinsamen Jahren."
      heroImage="https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1920&q=80"
      heroImageAlt="Ein Fenster am Morgen mit weißen Vorhängen — Sinnbild einer Trauerrede für die Schwester"
      questions={questionsPersonFemale}
      exampleQuote={
        <>
          „Wir haben uns über dieselbe Musik gestritten, dieselben Bücher heimlich gelesen und
          dieselbe Suppe geliebt, obwohl niemand sonst sie mochte. Sie war die, die zuerst
          verstanden hat, wer ich sein wollte — oft bevor ich es selbst wusste. Man vergisst
          eine Schwester nicht. Man trägt sie weiter.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
